<script>
import Modal from '@components/modal'
import { tableAction } from '@utils/mixins'
import { authComputed, userMethods } from '@state/helpers'
import store from '@state/store'

export default {
  components: { Modal },
  mixins: [tableAction],
  props: {
    profile: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      innerOpen: this.open,
      titleModal: '',
      inputProfile: [],
      formConfig: {
        labelPosition: 'left',
        modalSize: 'lg',
        formMode: 'Change'
      },
      submitValid: false,
    }
  },
  computed: {
    ...authComputed
  },
  watch: {
    open: {
      deep: true,
      handler: function(val) {
        this.innerOpen = val
        if (val) {
          if (this.profile === 'avatar') {
            this.titleModal = 'Avatar'
            this.inputProfile = [
              {
                type: 'file',
                placeholder: 'Choose image avatar',
                label: 'Avatar',
                name: 'avatar',
                value: [],
                validate: 'required'
              }
            ]
          } else {
            this.titleModal = 'Password'
            this.inputProfile = [
              {
                type: 'password',
                placeholder: 'password',
                label: 'Password',
                name: 'new_password',
                value: '',
                validate: 'required'
              },
              {
                type: 'password',
                placeholder: 'confirm password',
                label: 'Confirm Password',
                name: 'confirm_password',
                value: '',
                validate: 'required'
              }
            ]
          }
          this.$children[0].$refs['profile'].show()
        }
      }
    }
  },
  destroyed () {
    this.innerOpen = false
  },
  methods: {
    ...userMethods,
    closeModal(val) {
      this.$emit('modal-close')
    },
    openModal(val) {
      this.$emit('modal-open')
    },
    async submitModal(val) {
      if (this.profile === 'avatar') {
        this.submitValid = false
        let params = {
          avatar: val.avatar
        }
        const res = await this.changeAvatar({params})
        if (res.data.status === 200) {
          store.dispatch('auth/setAvatar', res.data.data.avatar)
          this.submitValid = true
          this.makeToast('Success', 'Avatar was updated successfully')
        } else {
          this.submitValid = false
          this.makeToast('Error', 'Error update avatar')
        }
      } else {
        let params = {
          user_id: this.currentUser.userId, 
          new_password: val.new_password,
          confirm_password: val.confirm_password
        }
        this.submitValid = false
        const res = await this.changePassword({params})        
        if (!res.data.data) {
          this.submitValid = false
          this.makeToast('Error', res.data.message, 'b-toaster-top-center')
        } else {
          this.submitValid = true
          this.makeToast('Succes', 'Password changed')
        }
      }
    }
  }
}
</script>

<template>
  <Modal v-bind="$attrs"
    :ref-modal="'profile'"
    :title-modal="titleModal"
    :form-config="formConfig"
    :inputs="inputProfile"
    :submit-valid="submitValid"
    @submit-form="submitModal($event)"
    @modal-open="openModal($event)"
    @modal-close="closeModal($event)" />
</template>